var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconImageFolderOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,8H6L5,8.74l-3,10.91L2,19.59V4.41L2.41,4H6.59L7,4.41V6H18.59l.41.41V7h2V6l-.29-.71-1-1L19,4H9l-.29-.71-1-1L7,2H2l-.71.29-1,1L0,4V20l.29.71,1,1L2,22H19l.71-.29,1-1,.25-.45,3-11ZM6.76,10H21.69l-.92,3.36L19.32,11.9H17.91L9.59,20H4Zm12.35,9.48-.52.52H12.46l6.14-6,1.57,1.56ZM11,17l.71-.29,1-1L13,15V13l-.29-.71-1-1L11,11H9l-.71.29-1,1L7,13v2l.29.71,1,1L9,17ZM9,13.41,9.41,13h1.18l.41.41v1.18l-.41.41H9.41L9,14.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageFolderOpen);
export default __webpack_public_path__ + "static/1787215617/media/icon-image-folder-open.df1db99a75d063f25c7e96e07325f3c4.svg";
export { ForwardRef as ReactComponent };